import { Injectable, Injector } from '@angular/core';

import { PecService } from '@services';
import { PecActions } from './pec.actions';

import { EApiCallStateKey } from '../api-call-state/api-call-state.enum';
import { Pec } from '@models';

import { SuperApiCallStateEffect } from '../effects/super-api-call-state.effect';
import { IApiRequest } from '@interfaces';
import { iif, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PecEffect extends SuperApiCallStateEffect<Pec[]> {
  apiCallStateKey = EApiCallStateKey.PEC;
  featureActions = PecActions;

  constructor(
    private service: PecService,
    injector: Injector
  ) {
    super(injector);
  }

  callApi(requestParams: IApiRequest) {
    // NOTE: if there are no filters we return empty array,
    // this is done to avoid calling api with empty filters and getting all data
    return iif(
      () => requestParams.filters?.length! > 0,
      this.service.get<Pec>(requestParams),
      of({ data: [] })
    );
  }
}
